import { useEffect, useState } from 'react';
import { useApi } from './useApi';

export interface ShippableCountry {
  value: string;       // UUID — kept for LookupItem compatibility, not used by forms
  label: string;       // localized country name
  code: string;        // ISO 3166-1 alpha-2 (SA, SD, EG) — what forms send to the backend
  phone_code: string;  // dial code shown in the dropdown (+966, +249, +20)
}

const PLACEHOLDERS: Record<string, string> = {
  SA: '05xxxxxxxx',
  SD: '09xxxxxxxx',
  EG: '010xxxxxxxxx',
};

export const phonePlaceholderFor = (code: string | undefined): string =>
  (code && PLACEHOLDERS[code]) || '';

/**
 * Fetches the recipient country dropdown options. Single source of truth for
 * the shippable-country list — keep all forms (single page + wizard) on this
 * hook so adding/removing a country is a one-line backend change.
 */
export function useShippableCountries() {
  const { get } = useApi();
  const [countries, setCountries] = useState<ShippableCountry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    get('/api/v1/lookups/countries', { shippable: 'true', lang: 'ar' })
      .then((res: any) => {
        const items = res?.items ?? [];
        setCountries(Array.isArray(items) ? items : []);
      })
      .catch(() => setCountries([]))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { countries, loading };
}
